/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".right-align[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.left-spacing[_ngcontent-%COMP%]{padding-left:15%!important}.spacing[_ngcontent-%COMP%]{padding:1em 4em 0!important}.rectangle[_ngcontent-%COMP%]{display:flex;justify-content:center;justify-items:center;width:25px;height:20px;border-radius:2px;background-color:rgba(169,204,227,.5)}"];
export { styles as styles };
